import React, { useContext } from 'react'
import { Col, Row } from 'antd'
import { t } from 'i18next'
import { Commands, Digicode, DisplayData, DisplayVersion, GepetoInfo } from './GepetoCommon'
import GlobalContext from '../GlobalContext'

export default function GepetoSummary ({ gepeto, setGepeto }) {
  const { screens } = useContext(GlobalContext)
  const span = screens.xs ? 24 : 4
  const largeSpan = screens.xs ? 24 : 6

  return (
    <div style={{ display: 'flex' }}>
      <Col>
        <Row>
          <Col span={span}>
            <h3>{t('Admin.GepetoPage.network')}</h3>
            <GepetoInfo gepeto={gepeto} />
          </Col>
          <Col span={span}>
            <h3>{t('Admin.GepetoPage.data')}</h3>
            <DisplayData gepeto={gepeto} />
          </Col>
          <Col span={span}>
            <h3>{t('Admin.GepetoPage.version')}</h3>
            <DisplayVersion gepeto={gepeto} />
          </Col>
          <Col span={largeSpan}>
            <h3>{t('Admin.GepetoPage.commands')}</h3>
            <Commands gepeto={gepeto} setGepeto={setGepeto} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>{t('Admin.GepetoPage.digicode')}</h3>
            <Digicode gepeto={gepeto} setGepeto={setGepeto} />
          </Col>
        </Row>
      </Col>
    </div>
  )
}
